(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["v2-journal-preview"] && !Shopify.designMode) return;
  try {
    
function initJournalTabs(){
 document.querySelectorAll('[data-journal-tabs]').forEach(root=>{
  if(root.dataset.tabsReady)return;
  root.dataset.tabsReady='true';
  const tabs=[...root.querySelectorAll('[data-journal-tab]')];
  const panels=tabs.map(tab=>root.querySelector('#'+CSS.escape(tab.getAttribute('aria-controls'))));
  const link=root.querySelector('[data-journal-category-link]');
  const select=index=>{
   tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;});
   link.href=tabs[index].dataset.url;
  };
  tabs.forEach((tab,i)=>{
   tab.addEventListener('click',()=>select(i));
   tab.addEventListener('keydown',event=>{
    let next=i;
    if(event.key==='ArrowRight')next=(i+1)%tabs.length;
    else if(event.key==='ArrowLeft')next=(i-1+tabs.length)%tabs.length;
    else if(event.key==='Home')next=0;
    else if(event.key==='End')next=tabs.length-1;
    else return;
    event.preventDefault();select(next);tabs[next].focus();
   });
  });
 });
}
initJournalTabs();
document.addEventListener('shopify:section:load',initJournalTabs);

  } catch(e) { console.error(e); }
})();
})();
